/**
 * Created by Administrador on 3/31/2017.
 */
(function(){
    'use strict';

    angular
        .module('completeAir')
        .factory('legendService',legendService);

    legendService.$inject = ['$http', 'CONFIG','messageService'];

    function legendService($http, CONFIG,messageService){
        var urlBase = CONFIG.API_URL + '/' + CONFIG.API_FLIGHT_CONTROL + '/' + CONFIG.API + '/legends';

        var service = {
            getLegends: getLegends,
            getLegendsPage: getLegendsPage,
            thereLegendByName: thereLegendByName
        }

        return service;

        function getLegends(){
            return $http.get(urlBase + '/list')
                .then(function (response) {
                    return response;
                })
                .catch(function () {
                    messageService.findAllError('');
                });
        }

        function getLegendsPage(page, size){
            return $http.get(urlBase + '/' + '?page=' + page + '&size=' + size)
                .then(function (response) {
                    return response;
                })
                .catch(function () {
                    messageService.findAllError('');
                });
        }

        function thereLegendByName(legends, name) {
            var res = false;
            for (var i = 0; i < legends.length; i++) {
                var legend = legends[i];
                if(legend.nameLegend === name) {
                    res = true;
                    break;
                }
            }
            return res;
        }
    }
})();
